import { Box, Typography, useTheme } from "@mui/material"
import { ReactElement } from "react"

/** When no users are found/returned the following will appear to the user */
const ZeroActiveUsersFoundMsg = (): ReactElement => {
    const theme = useTheme()
    return (
        <Typography variant="h6" component="div">
            You currently have{" "}
            <Box color={theme.palette.primary.main} display="inline">
                no active users
            </Box>{" "}
            to manage
        </Typography>
    )
}

export default ZeroActiveUsersFoundMsg
